export const PLU_COLORS: Record<string, string> = {
  U: "#3b82f6", // blue — Urbain
  AUc: "#93c5fd", // light blue — À Urbaniser central
  AUs: "#60a5fa", // mid blue — À Urbaniser strict
  N: "#16a34a", // green — Naturel
  A: "#ca8a04", // amber — Agricole
  default: "#6b7280",
}
